import { Controller, useFormContext } from 'react-hook-form';

import { WrappedTextArea } from '@quick/components/Forms';

import { useAppTranslation } from '@/app/i18n/client';

import { useFormDataContext } from './FormDataContext';
import type { IForm } from './types';

export function TransportConditions() {
  const { t } = useAppTranslation(['common', 'demand']);
  const { control } = useFormContext<IForm>();

  const { modality, serviceType } = useFormDataContext();
  const requiresConditions = modality?.transport_conditions;

  if (!requiresConditions) return null;
  return (
    <Controller
      control={control}
      rules={{
        shouldUnregister: true,
        required: {
          message: t('common:msg.required_field'),
          value: serviceType?.consignment_config ?? false,
        },
      }}
      name="transport_conditions"
      render={({ field, fieldState: { error } }) => (
        <WrappedTextArea
          isOnModal
          {...field}
          error={error?.message}
          id="waresDescription"
          label={t('demand:transportConditions.label')}
          placeholder={t('demand:transportConditions.placeholder')}
          className="sm:col-span-2"
          value={field.value ?? ''}
        />
      )}
    />
  );
}
